<template>
  <div
    class="flex w-full items-center justify-between"
    style="position: relative;"
  >
    <div class="w-full flex justify-start items-center">
      <vs-avatar
        :src="avatar"
        :text="avatarText"
        class="flex-shrink-0 mr-2"
        :color="AISEA_COLOR.LIGHT_BLUE"
        size="30px"
        style="cursor: default;"
      />
      <div class="ellipsis flex-1">{{ params.value }}</div>
      <div class="ml-2">
        <vs-tooltip :text="accountStatus.tooltip" position="top">
          <vs-icon
            :icon="accountStatus.icon"
            size="15px"
            :color="accountStatus.color"
          />
        </vs-tooltip>
        <div class="flex items-center"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererLink",
  mixins: [ColorMixin],
  data() {
    return {
      avatar: null,
      avatarText: "",
    };
  },
  created() {
    if (this.params.data.picture) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    } else {
      // this.avatarText = this.params.data.name ? this.params.data.name.charAt( 0 ) : '';
    }
  },
  computed: {
    accountStatus() {
      if (this.params.data.enterprise_crew_account) {
        return {
          tooltip: "アプリアカウント発行済",
          icon: "verified_user",
          color: this.AISEA_COLOR.BLUE,
        };
      } else {
        return {
          tooltip: "アプリアカウント未発行",
          icon: "privacy_tip",
          color: this.AISEA_COLOR.LIGHT_GRAY,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ellipsis {
  max-width: calc(100% - 30px - 15px - 1rem);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
